var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.json)?_c('div',[_c('DxDiagram',{ref:"diagram",attrs:{"id":"diagram","simple-view":true,"read-only":true},on:{"item-click":_vm.itemClick}},[_c('DxViewToolbar',{attrs:{"visible":false}})],1)],1):_c('div',[_c('div',{staticStyle:{"line-height":"470px","text-align":"center"}},[_vm._v("暂无数据")])])
}
var staticRenderFns = []

export { render, staticRenderFns }